var map = {
	"./ca.png": 33205,
	"./ch.png": 36612,
	"./de.png": 58664,
	"./en.png": 87764,
	"./es.png": 49617,
	"./fr.png": 83353,
	"./it.png": 79450,
	"./ja.png": 10902,
	"./jp.png": 31471,
	"./nl.png": 1951,
	"./pt.png": 48037,
	"./pt_BR.png": 67382,
	"./ru.png": 62122,
	"./zh.png": 80087
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85746;